import { useState, useEffect } from 'react';

interface useCalculatedDiscountProps {
  basePrice: number;
  currentPrice: number;
}

export const useCalculatedDiscount = ({ basePrice, currentPrice }: useCalculatedDiscountProps) => {
  const [calculatedDiscount, setCalculatedDiscount] = useState<number>(0);

  useEffect(() => {
    // calculate the discount based on the base price and the current price
    if (!basePrice || !currentPrice || basePrice <= currentPrice) {
      setCalculatedDiscount(0);
      return;
    } else {
      const discount = basePrice - currentPrice;
      const calculatedDiscount = (discount / basePrice) * 100;
      const roundedDiscount = Number(calculatedDiscount.toFixed(0));
      setCalculatedDiscount(roundedDiscount);
    }
  }, [basePrice, currentPrice]);

  return { calculatedDiscount };
};
